import {EventEmitter, Injectable} from '@angular/core';
import {QueueService} from './api/queue.service';
import {QueueModel} from '../models/queue.model';
import {MemberService} from './member.service';
import {MemberModel} from '../models/user.model';

@Injectable({
    providedIn: 'root',
})
export class FileQueueService {

    protected tasks = [];
    protected emitTasks: EventEmitter<QueueModel[]> = new EventEmitter<QueueModel[]>();

    protected timer;

    constructor(
        protected queueApi: QueueService,
        protected memberService: MemberService,
    ) {
    }

    updateTasks(): EventEmitter<QueueModel[]> {
        this.memberService.getCurrentMember().then((member: MemberModel) => {
            if (member) {
                this.queueApi.fileOperations().subscribe({
                    next: res => {
                        if (this.tasks.length > this.loadedCount()) {
                            this.resetTimer();
                        } else {
                            this.clearTimer();
                        }
                        this.emitTasks.emit(res.events);
                    }, error: () => {
                        this.clearTimer();
                    },
                });
            }
        });
        return this.emitTasks;
    }

    findNewTask(): EventEmitter<QueueModel[]> {
        this.resetTimer();
        return this.updateTasks();
    }

    resetTimer(): void {
        this.clearTimer();
        this.timer = setInterval(() => {
            this.updateTasks();
        }, 10000);
    }

    clearTimer(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    loadedCount(): number {
        return this.tasks.filter(x => x.status === 'ok').length;
    }

    errorQueue(): number {
        return this.tasks.filter(x => x.status === 'error').length;
    }
}
